import { createSlice } from "@reduxjs/toolkit";
import { TopSearchInitialState } from "../model/TopSearchReducerType";

const initialState: TopSearchInitialState = {
    inputValSearch: ""
};

const slice = createSlice({
    name: "TopSearchReducer",
    initialState,
    reducers: {
        setInputValSearch: (state, action) => {
            state.inputValSearch = action.payload;
        }
    }
});

export const TopSearchActions = slice.actions;
export default slice.reducer;